"use client";

import { Modal } from "react-bootstrap";
import { useRef, useEffect, useState } from "react";

interface CustomSigningOfferModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  block: {
    customSigningOfferForm: string;
  };
}

const CustomSigningOfferModal = (props: CustomSigningOfferModalProps) => {
  const { showModal, setShowModal, block } = props;
  const form = block?.customSigningOfferForm;
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const formHasMovedRef = useRef(false);
  const formDivRef = useRef<HTMLDivElement>(null);
  const [formId] = useState(
    () =>
      `custom-signing-offer-form-${Math.random().toString(36).substring(2, 9)}`,
  );

  // Watch for form to be populated by HubSpot, move it when ready
  useEffect(() => {
    const customSigningOfferFormDiv = formDivRef.current;

    if (!customSigningOfferFormDiv) return;

    // Set up observer from the start to catch when form initializes
    const observer = new MutationObserver(() => {
      const hasChildren = customSigningOfferFormDiv.children.length > 0;
      const modalBody = modalBodyRef.current;

      // If form has children and modal is open, move them
      if (hasChildren && showModal && !formHasMovedRef.current && modalBody) {
        while (customSigningOfferFormDiv.firstChild) {
          modalBody.appendChild(customSigningOfferFormDiv.firstChild);
        }
        formHasMovedRef.current = true;
      }
    });

    observer.observe(customSigningOfferFormDiv, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [showModal]);

  // Handle moving form when modal opens/closes
  useEffect(() => {
    const customSigningOfferFormDiv = formDivRef.current;
    const modalBody = modalBodyRef.current;

    if (!customSigningOfferFormDiv || !modalBody) return;

    if (showModal) {
      // If form has already been initialized, move children
      if (
        customSigningOfferFormDiv.children.length > 0 &&
        !formHasMovedRef.current
      ) {
        while (customSigningOfferFormDiv.firstChild) {
          modalBody.appendChild(customSigningOfferFormDiv.firstChild);
        }
        formHasMovedRef.current = true;
      }
    } else {
      // Move children back to formDiv when modal closes
      if (customSigningOfferFormDiv && formHasMovedRef.current) {
        while (modalBody.firstChild) {
          customSigningOfferFormDiv.appendChild(modalBody.firstChild);
        }
        formHasMovedRef.current = false;
      }
    }
  }, [showModal]);

  return (
    <>
      <div
        ref={formDivRef}
        id={formId}
        style={{ display: "none" }}
        suppressHydrationWarning={true}
        dangerouslySetInnerHTML={{
          __html: form || "",
        }}
      />
      <Modal
        show={showModal}
        centered
        onHide={() => setShowModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Egyedi ajánlat kérése</Modal.Title>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef}></Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomSigningOfferModal;
